const images = import.meta.glob('../avatars/*.png', { eager: true });

const avatarMap: Record<string, string> = {};

for (const path in images) {
  const filename = path.split('/').pop();
  if (filename) {
    // @ts-expect-error Types are known.
    avatarMap[filename] = images[path].default;
  }
}

export default avatarMap;
